import { BASE_MENU_HEAD, ADMIN_ONLY, BASE_MENU_TAIL } from "./menuItems";

// Shared entries live in menuItems.jsx — edit there, not here, so this and
// userMenu.jsx cannot drift apart again.
const adminMenu = [...BASE_MENU_HEAD, ...ADMIN_ONLY, ...BASE_MENU_TAIL];

export default adminMenu;
